import { render, staticRenderFns } from "./SwapperMessages.vue?vue&type=template&id=39d5fc74&scoped=true&"
import script from "./SwapperMessages.vue?vue&type=script&lang=js&"
export * from "./SwapperMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d5fc74",
  null
  
)

export default component.exports